// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Inter_Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Inter';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

:root {
    --sidebar-width: 72px;
    --sidebar-width-collapsed: 56px;
    --navbar-height: 56px;
    --transition-fast: 0.15s ease;
    --transition-normal: 0.2s ease;
    --transition-slow: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

html {
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
}

body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    overflow: hidden;
    background-color: #F8FAFC;
    color: #0F172A;
}

* {
    box-sizing: border-box;
}

/* Modern scrollbar styling */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: #CBD5E1;
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #94A3B8;
}

/* Firefox scrollbar */
* {
    scrollbar-width: thin;
    scrollbar-color: #CBD5E1 transparent;
}

/* Focus styles for accessibility */
*:focus-visible {
    outline: 2px solid #2563EB;
    outline-offset: 2px;
}

*:focus:not(:focus-visible) {
    outline: none;
}

/* Smooth transitions */
a, button {
    transition: color var(--transition-fast), background-color var(--transition-fast), border-color var(--transition-fast), box-shadow var(--transition-fast);
}

/* Selection styling */
::selection {
    background-color: rgba(37, 99, 235, 0.15);
    color: #0F172A;
}

/* Animation keyframes */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes slideIn {
    from { opacity: 0; transform: translateX(-8px); }
    to { opacity: 1; transform: translateX(0); }
}

@keyframes scaleIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
}

/* Reduced motion preference */
@media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
    }
}

/* Toast overrides for modern look */
.Toastify__toast {
    border-radius: 10px !important;
    font-family: 'Inter', sans-serif !important;
    font-size: 0.875rem !important;
    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,+DAAwD;IACxD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,qBAAqB;IACrB,6BAA6B;IAC7B,8BAA8B;IAC9B,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,uFAAuF;IACvF,mCAAmC;IACnC,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,6BAA6B;AAC7B;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA,mCAAmC;AACnC;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,yJAAyJ;AAC7J;;AAEA,sBAAsB;AACtB;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,OAAO,UAAU,EAAE,sBAAsB,EAAE;IAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,8BAA8B;AAC9B;IACI;QACI,qCAAqC;QACrC,uCAAuC;QACvC,sCAAsC;IAC1C;AACJ;;AAEA,oCAAoC;AACpC;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,8BAA8B;IAC9B,uFAAuF;AAC3F","sourcesContent":["@font-face {\n    font-family: 'Inter';\n    src: url('./fonts/Inter_Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n:root {\n    --sidebar-width: 72px;\n    --sidebar-width-collapsed: 56px;\n    --navbar-height: 56px;\n    --transition-fast: 0.15s ease;\n    --transition-normal: 0.2s ease;\n    --transition-slow: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nhtml {\n    font-size: 16px;\n    -webkit-text-size-adjust: 100%;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    height: 100%;\n    overflow: hidden;\n    background-color: #F8FAFC;\n    color: #0F172A;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n/* Modern scrollbar styling */\n::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: #CBD5E1;\n    border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background-color: #94A3B8;\n}\n\n/* Firefox scrollbar */\n* {\n    scrollbar-width: thin;\n    scrollbar-color: #CBD5E1 transparent;\n}\n\n/* Focus styles for accessibility */\n*:focus-visible {\n    outline: 2px solid #2563EB;\n    outline-offset: 2px;\n}\n\n*:focus:not(:focus-visible) {\n    outline: none;\n}\n\n/* Smooth transitions */\na, button {\n    transition: color var(--transition-fast), background-color var(--transition-fast), border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n/* Selection styling */\n::selection {\n    background-color: rgba(37, 99, 235, 0.15);\n    color: #0F172A;\n}\n\n/* Animation keyframes */\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(4px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideIn {\n    from { opacity: 0; transform: translateX(-8px); }\n    to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes scaleIn {\n    from { opacity: 0; transform: scale(0.95); }\n    to { opacity: 1; transform: scale(1); }\n}\n\n/* Reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n    *, *::before, *::after {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n    }\n}\n\n/* Toast overrides for modern look */\n.Toastify__toast {\n    border-radius: 10px !important;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 0.875rem !important;\n    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
